import React from 'react';

function PlayIcon({ width = 42, height = 42, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 42 42">
      <g>
        <path d="M20.75,41.4543075 C9.29028322,41.4543075 0,32.1746367 0,20.7271537 C0,9.2796708 9.29028322,0 20.75,0 C32.2097168,0 41.5,9.2796708 41.5,20.7271537 C41.5,32.1746367 32.2097168,41.4543075 20.75,41.4543075 Z M20.75,39.9543075 C31.3816732,39.9543075 40,31.3458255 40,20.7271537 C40,10.108482 31.3816732,1.5 20.75,1.5 C10.1183268,1.5 1.5,10.108482 1.5,20.7271537 C1.5,31.3458255 10.1183268,39.9543075 20.75,39.9543075 Z" />
        <polygon points="16 13.139331 29.9808689 21.2355902 16 28.9406815" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default PlayIcon;
